import { deleteCookie } from 'cookies-next';
import { create } from 'zustand';
import { useApp } from '@/forApp/states/appState/appState';
import fetcher from '@/forApp/utils/fetcher/fetcher';
import { UserForStateT, UserState } from './types';

export const useUser = create<UserState>()((set, getState) => ({
  user: null,
  favorites: [],
  getFavorites: async () => {
    try {
      const response = await fetcher<number[]>(
        'GET',
        '/personal/favorites?only-ids',
      );
      return set((state) => ({ ...state, favorites: response.data }));
    } catch {}
  },
  deleteFavorite: async (id: number) => {
    set((state) => ({
      ...state,
      favorites: state.favorites.filter((fav) => fav !== id),
    }));
    try {
      await fetcher('DELETE', `/personal/favorites/${id}`);
      useApp.getState().addNotification({
        text: 'Объявление удалено из избранного',
        type: 'success',
      });
      getState().getFavorites();
    } catch (error) {
      set((state) => ({ ...state, favorites: [...state.favorites, id] }));
      useApp.getState().addNotification({
        text: 'Не удалось удалить из избранного',
        type: 'error',
      });
      console.error(error);
    }
  },
  addFavorite: async (id: number) => {
    set((state) => ({ ...state, favorites: [...state.favorites, id] }));
    try {
      await fetcher('POST', '/personal/favorites', {
        body: JSON.stringify({
          entity_id: id,
        }),
      });
      useApp.getState().addNotification({
        text: 'Объявление добавлено в избранное',
        type: 'success',
      });
      getState().getFavorites();
    } catch (error) {
      set((state) => ({
        ...state,
        favorites: state.favorites.filter((fav) => fav !== id),
      }));
      useApp.getState().addNotification({
        text: 'Не удалось добавить в избранное',
        type: 'error',
      });
      console.error(error);
    }
  },
  getUser: async () => {
    try {
      const response = await fetcher<UserForStateT>('GET', '/personal/profile');
      getState().getFavorites();
      return set((state) => ({ ...state, user: response.data }));
    } catch (error) {
      console.error(error);
    }
  },
  logout: () => {
    deleteCookie('cg-token');
    return set((state) => ({ ...state, user: null }));
  },
}));
